import React, { useEffect } from 'react';
import { useState } from 'react';
import { useUIControlsStore } from '../../redux/features/ui-controls';

const IdleTimerSessionModal = () => {
  const { showSessionExpiredModal, updateShowSessionExpiredModal } =
    useUIControlsStore();

  const [shouldRedirectCustomer, setShouldRedirectCustomer] = useState(false);

  const sessionModalButtonHandler = () => {
    updateShowSessionExpiredModal(false);
    window.location.assign('/');
  };

  useEffect(() => {
    if (showSessionExpiredModal) {
      setShouldRedirectCustomer(true);
    }

    if (shouldRedirectCustomer) {
      window.onload = function () {
        // DOCS: Removed for over-refreshing performance drop reason
        // window.location.assign('/');
      };
    }
  }, [shouldRedirectCustomer, showSessionExpiredModal]);

  return (
    <>
      {showSessionExpiredModal ? (
        <>
          <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"></div>{' '}
          <div
            className="res150-overlay fixed top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden bg-gray-700 opacity-100 flex flex-col items-center justify-center p-2"
            style={{ background: 'rgb(0,0,0,0.8)', zIndex: 50 }}
          >
            <div className="bg-white rounded-lg flex flex-col m-auto p-3">
              {' '}
              <div className="max-w-[300px] text-center w-full flex flex-col justify-center items-center p-3">
                <p className="font-bold">Session Expired</p>
                <br />
                <p className="font-normal">
                  User session expired, Please login again
                </p>
              </div>
              <div className="flex flex-row justify-center items-center">
                <button
                  style={{
                    background: '#079F9F',
                    border: '1px solid #079F9F',
                    color: '#fff',
                    borderRadius: '5px',
                  }}
                  className="bg-whitetext-white inline-block m-1 px-2 py-2  rounded-lg text-sm font-semibold focus:outline-none tracking-wider transition duration-200 ease-in-out w-full "
                  onClick={sessionModalButtonHandler}
                >
                  Okay, Got it
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default IdleTimerSessionModal;
